/**
 * Multi-colored Celebration Confetti Explosion.
 */
import { ParticleSystem, Particle } from './ParticleSystem';
import { SVGObjectConfig } from '../objects/SVGObject';

export class ConfettiEffect extends ParticleSystem {
  constructor(config: SVGObjectConfig) {
    super(config, 80);
    this.emitRate = 40;
  }

  protected createParticle(): Particle {
    const colors = ['#ef4444', '#3b82f6', '#10b981', '#f59e0b', '#ec4899', '#8b5cf6'];
    const angle = Math.random() * Math.PI * 2;
    const speed = 120 + Math.random() * 180;
    return {
      x: 0,
      y: 0,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      size: 4 + Math.random() * 5,
      alpha: 1,
      life: 0,
      maxLife: 1.6,
      color: colors[Math.floor(Math.random() * colors.length)]
    };
  }

  protected updateParticle(p: Particle, delta: number): void {
    p.vy += 220 * delta; // Gravity
    p.x += p.vx * delta;
    p.y += p.vy * delta;
    p.alpha = Math.max(0, 1 - p.life / p.maxLife);
  }
}
